import { AccesSearchResult } from './acces-search-result';
import { AccesSearchCriteria } from './acces-search-criteria';

export class AccesSearchResultsWithCriteria {
	
	searchResults!: AccesSearchResult[];
	criteria!: AccesSearchCriteria;
	
	constructor(searchResults: AccesSearchResult[], criteria: AccesSearchCriteria) {
		this.searchResults = searchResults;
		this.criteria = criteria;
	}

}